import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8 } from "styled-components";
import { RichText } from "~/features/ui/rich-text";
import { Headline } from "~/features/ui/headline";
import { Grid } from "~/features/ui/grid";
export type HeaderProps = {
  eyebrow?: React.ReactNode;
  headline?: string;
  text?: string;
  link?: React.ReactNode;
  filterBar?: React.ReactNode;
  alignment: "horizontal" | "vertical";
  /**
   * Left-align the headline in its column instead of the default bottom-right
   * placement. The horizontal header is built to pair a left eyebrow with a
   * right headline; listing sections that carry only a title (e.g. the Webinars
   * overview grids) opt into this so the title sits at the content's left edge.
   */
  headlineStart?: boolean;
};
function HorizontalHeader(props: HeaderProps) {
  const {
    eyebrow,
    headline,
    text,
    link,
    filterBar,
    headlineStart
  } = props;
  return <_StyledGrid>
      {eyebrow && <_StyledDiv $_css={[{
      "gridColumn": "1 / -1",
      "display": "flex",
      "flexDirection": "column",
      "rowGap": "0.8rem",
      "@media (min-width: 1024px)": {
        "gridColumn": "span 6 / span 6"
      }
    }]}>{eyebrow}</_StyledDiv>}

      <_StyledDiv2 $_css2={[{
      "gridColumn": "1 / -1",
      "display": "none",
      "rowGap": "var(--spacing-md)",
      "@media (min-width: 1024px)": {
        "gridColumn": "span 6 / span 6",
        "display": "flex",
        "flexDirection": "column",
        "rowGap": "var(--spacing-lg)"
      }
    }, headlineStart ? {
      "@media (min-width: 1024px)": {
        "placeSelf": "start"
      }
    } : {
      "@media (min-width: 1024px)": {
        "placeSelf": "end"
      }
    }]}>
        {headline && <_StyledHeadline type="h2" text={headline} />}
        {text && <RichText text={text} />}
        {link && <div>{link}</div>}
        {filterBar && <_StyledDiv3 $_css3={[{
        "gridColumn": "1 / -1",
        "marginTop": "var(--spacing-xl)",
        "display": "flex"
      }]}>{filterBar}</_StyledDiv3>}
      </_StyledDiv2>
    </_StyledGrid>;
}
function VerticalHeader(props: HeaderProps) {
  const {
    eyebrow,
    headline,
    text,
    link,
    filterBar
  } = props;
  return <_StyledDiv4>
      {eyebrow}
      {headline && <_StyledHeadline2 type="h2" text={headline} />}
      {(link || text) && <_StyledDiv5 $_css4={[{
      "marginTop": "auto",
      "display": "flex",
      "flexDirection": "column",
      "rowGap": "1.6rem"
    }]}>
          {text && <RichText text={text} />}
          {link && <div>{link}</div>}
        </_StyledDiv5>}
      {filterBar}
    </_StyledDiv4>;
}
export function SectionHeader(props: HeaderProps) {
  return props.alignment === "horizontal" ? <HorizontalHeader {...props} /> : <VerticalHeader {...props} />;
}
var _StyledGrid = _styled(Grid).withConfig({
  componentId: "sc-sf-1jee11t-0"
})({
  "rowGap": "1.6rem"
});
var _StyledDiv = _styled2("div").withConfig({
  componentId: "sc-sf-1jee11t-1"
})`${p => p.$_css}`;
var _StyledDiv2 = _styled3("div").withConfig({
  componentId: "sc-sf-1jee11t-2"
})`${p => p.$_css2}`;
var _StyledHeadline = _styled4(Headline).withConfig({
  componentId: "sc-sf-1jee11t-3"
})({
  "fontSize": "2.4rem",
  "lineHeight": "1.2",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "3.8rem",
    "lineHeight": "1.3",
    "letterSpacing": "0.038rem",
    "fontWeight": "400"
  }
});
var _StyledDiv3 = _styled5("div").withConfig({
  componentId: "sc-sf-1jee11t-4"
})`${p => p.$_css3}`;
var _StyledDiv4 = _styled6("div").withConfig({
  componentId: "sc-sf-1jee11t-5"
})({
  "display": "flex",
  "height": "100%",
  "flexDirection": "column",
  "rowGap": "1.6rem"
});
var _StyledHeadline2 = _styled7(Headline).withConfig({
  componentId: "sc-sf-1jee11t-6"
})({
  "fontSize": "2.4rem",
  "lineHeight": "1.2",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "3.8rem",
    "lineHeight": "1.3",
    "letterSpacing": "0.038rem",
    "fontWeight": "400"
  }
});
var _StyledDiv5 = /*#__PURE__*/_styled8("div").withConfig({
  displayName: "header___StyledDiv5",
  componentId: "sc-kv3pdz-0"
})(["", ""], p => p.$_css4);